const Keys = {
    selected_region: "selected_region",
    access_token: "access_token",
    refresh_token: "refresh_token",
    expires_in: "expires_in",
    is_login: "is_login"
}

export default Keys